import React                                      from 'react'
import {Box, IconButton, Typography, useTheme}    from '@mui/material'
import {alpha}                                    from '@mui/material/styles'
import {Close}                                    from '@mui/icons-material'
import ReactMarkdown                              from 'react-markdown'
import {severityAccent, severityIcon}             from '../../util/announcement-severity'

/*
 * The announcement as a banner (190) -- for something worth saying but not worth interrupting for,
 * such as a maintenance window.
 *
 * FIXED, below the Navbar, rather than a band inside the page. AppLayout computes its own top
 * offset for the Navbar and study mode, and adding a element to that column would mean changing
 * that geometry for every screen. The trial banner's navbar chip solved the same problem the same
 * way (169), so an app-wide strip floating over the page is the established pattern here rather
 * than a new one.
 *
 * --navbar-height is published on the document element by AuthGate, so this sits under the Navbar
 * at whatever height it currently is. AnnouncementGate never renders this in study mode, where
 * there is no Navbar, so the variable is always meaningful when this is on screen.
 */
const AnnouncementBanner = ({announcement, onDismiss}) => {
	const theme = useTheme()
	const custom = theme.custom

	const accent = severityAccent(announcement.severity, custom)
	const Icon = severityIcon(announcement.severity)

	return (
		<Box sx={{
			position: 'fixed',
			top: 'calc(var(--navbar-height, 64px) + 8px)',
			left: '50%',
			transform: 'translateX(-50%)',
			zIndex: 1300,
			width: 'calc(100% - 24px)',
			maxWidth: 720,
			display: 'flex',
			alignItems: 'flex-start',
			gap: 1.5,
			px: {xs: 1.5, sm: 2},
			py: {xs: 1.25, sm: 1.5},
			background: custom.bg.hud,
			border: `1px solid ${alpha(accent, 0.55)}`,
			borderLeft: `4px solid ${accent}`,
			borderRadius: `${custom.radius.md}px`,
			boxShadow: custom.shadow.pop,
		}}>
			<Icon sx={{color: accent, fontSize: 20, mt: '1px', flexShrink: 0}}/>

			<Box sx={{flex: 1, minWidth: 0}}>
				<Typography sx={{
					fontSize: custom.fontSize.base,
					fontWeight: custom.fontWeight.semibold,
					color: custom.text.main,
				}}>
					{announcement.title}
				</Typography>
				{announcement.body && (
					<Box sx={{
						mt: 0.25,
						fontSize: custom.fontSize.sm,
						color: custom.text.muted,
						lineHeight: 1.5,
						'& p': {m: 0},
						'& p + p': {mt: 0.5},
						'& a': {color: custom.link},
					}}>
						<ReactMarkdown>{announcement.body}</ReactMarkdown>
					</Box>
				)}
			</Box>

			{/* closing is the acknowledgement -- see the note in AnnouncementDialog */}
			<IconButton size="small" onClick={onDismiss} sx={{color: custom.text.muted, flexShrink: 0}}>
				<Close fontSize="small"/>
			</IconButton>
		</Box>
	)
}

export default AnnouncementBanner
